import { useGetSections } from "../../../../../hooks/api/queries/useSection";

export const useBasicServiceForm = () => {
  const { data: sections, isLoading: isLoadingSections } = useGetSections();

  return {
    sections,
    isLoading: isLoadingSections,
  };
};
